import React, { useState, useEffect } from "react";

const visaTypes = ["F1/F2", "B1/B2", "J1/J2", "M1/M2"];

export default function AnimatedHeading() {
  const [currentVisaIndex, setCurrentVisaIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);

      setTimeout(() => {
        setCurrentVisaIndex((prevIndex) =>
          prevIndex === visaTypes.length - 1 ? 0 : prevIndex + 1
        );
        setIsAnimating(false);
      }, 200);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <h1 className="text-5xl font-semibold tracking-tight text-balance text-primaryColor sm:text-7xl leading-tight">
      Prepare for <br /> Your {""}
      <span
        className={`inline-block font-bold text-[#A881DB] transition-all duration-200 ease-in-out ${
          isAnimating
            ? "opacity-0 transform -translate-y-2 scale-95"
            : "opacity-100 transform translate-y-0 scale-100"
        }`}
      >
        {visaTypes[currentVisaIndex]}
      </span>
      <br />
      <span className="font-semibold">Visa Interview</span> with Confidence
    </h1>
  );
}
